import { ReduxStore } from 'store/types';

function forgotPasswordIsLoading(state: ReduxStore): boolean {
  return state.auth.forgotPassword.config.isLoading;
}

export default forgotPasswordIsLoading;
